import { HUYASdk } from '@hy-hybrid/kiwi-js-sdk';
import { Toast } from 'antd-mobile'
import yaReport from '@/modules/ya-report/ya-report';
import { getCookieVal } from '@/modules/util/util';
const IN_HUYA_APP = navigator.userAgent.indexOf('huya') > 0;
const netWork = () => {

  function updateOnlineStatus() {
    try {
      !navigator.onLine && Toast.show({
        content: `网络已断开`,
      });
    } catch (err) {
      console.log(err);
    }
  }

  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);
}

function performance() {
  // 使用 PerformanceObserver 监听 fcp
  if (window.PerformanceObserver) {
    try {
      const type = 'paint';
      if ((PerformanceObserver.supportedEntryTypes || []).includes(type)) {
        const observer = new PerformanceObserver(entryList => {
          for (const entry of entryList.getEntriesByName('first-contentful-paint')) {
            const { startTime } = entry;
            // TTFB：Time To First Byte，首字节时间
            // FP：First Paint，首次绘制，绘制Body
            // FCP：First Contentful Paint，首次有内容的绘制，第一个dom元素绘制完成
            // FMP：First Meaningful Paint，首次有意义的绘制
            // TTI：Time To Interactive，可交互时间，整个内容渲染完成
            // 链接：https://juejin.cn/post/7083709121995735047
            console.log('[assets-load-monitor] PerformanceObserver FCP:', startTime);
            const apiTimeObj = {
              handle: 'apiTime',
              data: {
                apiName: 'FCP', // 接口名字
                unique: +new Date(),  // 唯一（时间戳）
                identity: {
                  status: 'start',  // 前置打点
                  times: 0, //  开始请求时间
                },
                msg: '', // 可选项，用于日志分析
              },
            }
            window.hyReport.hmt.push(apiTimeObj)

            // 后置打点
            apiTimeObj.data.identity = {
              status: 'end',  // 后置打点
              times: startTime, // 结束请求时间
            }
            window.hyReport.hmt.push(apiTimeObj);
          }
        });
        observer.observe({
          entryTypes: [type],
        });
        return;
      }
    } catch (e) {
      // ios 不支持这种entryTypes，会报错 https://caniuse.com/?search=PerformancePaintTiming
      console.warn('[assets-load-monitor] PerformanceObserver error:', (e || {}).message ? e.message : e);
    }
  }
}
performance();

netWork();

if (UMI_ENV !== 'prod' && IN_HUYA_APP) {
  /* eslint-disable new-cap */
  // window.eruda.init();
  new window.PageSpy({
    title: `我的等级-${getCookieVal('udb_uid')}`,
    autoRender: false,
  });
  /* eslint-disable new-cap */
}

window.TASK_CENTER_URL = 'https://hd.huya.com/h5/welfare_center/index.html?hideBar=1';

if (UMI_ENV !== 'prod') {
  window.TASK_CENTER_URL = 'https://test-hd.huya.com/h5/welfare_center/test/index.html?hideBar=1';
}


console.warn(window.location.href)

window.yaReportArr = [];
yaReport({
  pro: 'huyawap',
});

// @ts-ignore
HUYASdk.JSBridge.invoke('setAllowRefresh', { allowRefresh: false }, {});


window.hyReport.firstScreenTime = +new Date()